if (!customElements.get('nue-slider')) customElements.define('nue-slider', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const signal = this.abort.signal, track = this.querySelector('[data-track]');
    if (!track) return;
    const slides = [...track.querySelectorAll('[data-slide]')], status = this.querySelector('[data-status]');
    const index = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    const move = delta => track.scrollTo({left: ((index()+delta+slides.length)%slides.length)*track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    this.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1),{signal});
    this.querySelector('[data-next]')?.addEventListener('click',()=>move(1),{signal});
    const update = () => { const active = index(); if(status) status.textContent = `${active+1} / ${slides.length}`; slides.forEach((slide,i)=>{slide.inert=i!==active;}); };
    track.addEventListener('scroll',update,{passive:true,signal});
    this.addEventListener('shopify:block:select', e => {const i=slides.indexOf(e.target.closest('[data-slide]'));if(i>=0)track.scrollTo({left:i*track.clientWidth});},{signal}); update();
  }
  disconnectedCallback(){this.abort?.abort();}
});
function nueHoverMenus(root = document) {
  root.querySelectorAll('header-menu').forEach(menu => {
    if (menu.dataset.nueHover) return;
    menu.dataset.nueHover = 'true';
    const details = menu.querySelector('details.mega-menu');
    if (!details) return;
    const summary = details.querySelector('summary');
    let timer;
    const close = () => { details.open = false; summary.setAttribute('aria-expanded','false'); };
    menu.addEventListener('pointerenter', () => {
      if (!matchMedia('(min-width:990px) and (hover:hover)').matches) return;
      clearTimeout(timer);
      document.querySelectorAll('details.mega-menu[open]').forEach(other => {
        if (other !== details) { other.open = false; other.querySelector('summary').setAttribute('aria-expanded','false'); }
      });
      details.open = true; summary.setAttribute('aria-expanded','true');
    });
    menu.addEventListener('pointerleave', () => {
      if (matchMedia('(min-width:990px) and (hover:hover)').matches) timer = setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 160);
    });
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { clearTimeout(timer); close(); summary.focus(); } });
  });
}
document.addEventListener('shopify:section:load', event => nueHoverMenus(event.target));
document.addEventListener('DOMContentLoaded', () => {
  const announcement = document.querySelector('.announcement-bar-section');
  if(announcement){const syncAnnouncement=()=>document.documentElement.style.setProperty('--nue-announcement-height',`${announcement.getBoundingClientRect().height}px`);new ResizeObserver(syncAnnouncement).observe(announcement);syncAnnouncement();}
  nueHoverMenus();
  document.querySelectorAll('.nue-hero video').forEach(video => {
    video.controls = false;
    video.removeAttribute('controls');
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('playsinline', '');
    video.play().catch(() => {});
  });
  document.querySelectorAll('.nue-hero-products').forEach(products => {
    const track = products.querySelector('[data-product-track]');
    const cards = [...products.querySelectorAll('.nue-hero-product-card')];
    const move = direction => track?.scrollBy({left: direction * Math.max(track.clientWidth * .82, 260), behavior: 'smooth'});
    products.querySelector('[data-product-prev]')?.addEventListener('click', () => move(-1));
    products.querySelector('[data-product-next]')?.addEventListener('click', () => move(1));
    if (cards.length < 2) products.classList.add('is-single');
  });
});
if (!customElements.get('nue-tabs')) customElements.define('nue-tabs', class extends HTMLElement {
  connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
    const tabs=[...this.querySelectorAll('[data-tab]')], panels=[...this.querySelectorAll('[data-panel]')];
    const activate=(i,focus=false)=>{tabs.forEach((tab,n)=>{tab.setAttribute('aria-selected',n===i?'true':'false');tab.tabIndex=n===i?0:-1;});panels.forEach((panel,n)=>panel.hidden=n!==i);if(focus)tabs[i]?.focus();};
    tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(i),{signal});tab.addEventListener('keydown',e=>{let next=i;if(e.key==='ArrowRight')next=(i+1)%tabs.length;else if(e.key==='ArrowLeft')next=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();activate(next,true);},{signal});});
    this.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[data-panel]');if(panel)activate(Number(panel.dataset.panel));},{signal});
  }
  disconnectedCallback(){this.abort?.abort();}
});
